/*
 * Potzillas — Header enhancements
 * Desktop hover-to-open pro mega menu / dropdown.
 * Nechává Dawn click chování netknuté (click na parent toggluje).
 */
(function () {
  const DESKTOP_MQ = '(min-width: 990px)';
  const CLOSE_DELAY = 150;

  function init() {
    const mql = window.matchMedia(DESKTOP_MQ);
    const menus = Array.from(document.querySelectorAll('header-menu'));

    // Map header-menu -> { details, summary, closeTimer }
    const state = new Map();

    const closeMenu = (menu) => {
      const s = state.get(menu);
      if (!s) return;
      clearTimeout(s.closeTimer);
      if (s.details.open) {
        s.details.open = false;
        if (s.summary) s.summary.setAttribute('aria-expanded', 'false');
      }
    };

    const openMenu = (menu) => {
      const s = state.get(menu);
      if (!s) return;
      clearTimeout(s.closeTimer);
      // Zavři všechny ostatní menu okamžitě
      menus.forEach((other) => {
        if (other !== menu) closeMenu(other);
      });
      if (!s.details.open) {
        s.details.open = true;
        if (s.summary) s.summary.setAttribute('aria-expanded', 'true');
      }
    };

    const scheduleClose = (menu) => {
      const s = state.get(menu);
      if (!s) return;
      clearTimeout(s.closeTimer);
      s.closeTimer = setTimeout(() => closeMenu(menu), CLOSE_DELAY);
    };

    menus.forEach((menu) => {
      const details = menu.querySelector('details');
      if (!details) return;
      const summary = details.querySelector('summary');
      state.set(menu, { details, summary, closeTimer: null });

      menu.addEventListener('mouseenter', () => {
        if (!mql.matches) return;
        openMenu(menu);
      });

      menu.addEventListener('mouseleave', () => {
        if (!mql.matches) return;
        scheduleClose(menu);
      });

      menu.addEventListener('focusin', () => {
        if (!mql.matches) return;
        openMenu(menu);
      });
    });
  }

  // Mobilní drawer: celý řádek parentu rozbaluje podmenu (Dawn default).
  // Do kolekce parentu se jde přes odkaz „Všechny …" uvnitř podmenu
  // (viz snippets/header-drawer.liquid) — žádný matoucí split tap.

  function boot() {
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify editor překresluje sekce
  document.addEventListener('shopify:section:load', init);
})();
